export { default } from '@shikijs/langs/python'
